import { FormBuilder, Validators } from '@angular/forms';
import { FailureCategory } from '../../../../go/model/form.model';

export function buildFailureForm(fb: FormBuilder, disabled: boolean, defectName: string) {
  return fb.group({
    name: fb.control({value: defectName, disabled}, {nonNullable: true, validators: [Validators.required]}),
    photos: fb.control({value: '', disabled}, {nonNullable: true, validators: []}),
    category: fb.control({value: null as FailureCategory | null, disabled}),
    failureCodes: fb.control({value: null as unknown as string | string[], disabled}, {nonNullable: true, validators: [Validators.required]})
  });
}
